import { defineNuxtPlugin } from '#app/nuxt'
import { LazyDsAvatar, LazyDsBreadCrumb, LazyDsCrumb, LazyDsButtonBase, LazyDsButtonCounter, LazyDsButtonCritical, LazyDsButtonIconBase, LazyDsButtonIconCritical, LazyDsButtonIconPrimary, LazyDsButtonIconSecondary, LazyDsButtonIconTertiary, LazyDsButtonPrimary, LazyDsButtonSecondary, LazyDsButtonTertiary, LazyDsCardGroup, LazyDsCardHorizontal, LazyDsCardVertical, LazyDsCheckbox, LazyDsDividerSimple, LazyDsDropdown, LazyDsDropdownDivider, LazyDsDropdownEmpty, LazyDsDropdownList, LazyDsDropdownListBase, LazyDsDropdownListItem, LazyDsDropdownListItemRich, LazyDsDropdownSection, LazyDsDropzone, LazyDsFieldBase, LazyDsFieldMultiline, LazyDsFieldNumber, LazyDsFieldTags, LazyDsFieldText, LazyDsHeader, LazyDsProfileHeader, LazyDsIcon, LazyDsImage, LazyDsDrawer, LazyDsOverlayFooter, LazyDsOverlayHeader, LazyDsRadioButton, LazyDsSelect, LazyDsSidebar, LazyDsSidebarItem, LazyDsSidebarItemBase, LazyDsSidebarItemChild, LazyDsSidebarSection, LazyDsEmptyState, LazyDsPagination, LazyDsTable, LazyDsTableHeaderCell, LazyDsTableLine, LazyDsTableLineCellActions, LazyDsTableLineCellAvatar, LazyDsTableLineCellBase, LazyDsTableLineCellButtons, LazyDsTableLineCellDrag, LazyDsTableLineCellIcon, LazyDsTableLineCellLabel, LazyDsTableLineCellLink, LazyDsTableLineCellMore, LazyDsTableLineCellNumeric, LazyDsTableLineCellRich, LazyDsTableLineCellSelect, LazyDsTableLineCellStatus, LazyDsTableLineCellTags, LazyDsTabList, LazyDsTabListItem, LazyDsTag, LazyDsTagAction, LazyDsTagStatus, LazyDsTextBody, LazyDsTextHeading, LazyDsToggle, LazyDsTooltip, LazyDsTopbar, LazyDsTopbarInput, LazyDsTopbarUserSearch, LazyDsTopbarUserSearchItem, LazyNuxtNotifications } from '#components'
const lazyGlobalComponents = [
  ["DsAvatar", LazyDsAvatar],
["DsBreadCrumb", LazyDsBreadCrumb],
["DsCrumb", LazyDsCrumb],
["DsButtonBase", LazyDsButtonBase],
["DsButtonCounter", LazyDsButtonCounter],
["DsButtonCritical", LazyDsButtonCritical],
["DsButtonIconBase", LazyDsButtonIconBase],
["DsButtonIconCritical", LazyDsButtonIconCritical],
["DsButtonIconPrimary", LazyDsButtonIconPrimary],
["DsButtonIconSecondary", LazyDsButtonIconSecondary],
["DsButtonIconTertiary", LazyDsButtonIconTertiary],
["DsButtonPrimary", LazyDsButtonPrimary],
["DsButtonSecondary", LazyDsButtonSecondary],
["DsButtonTertiary", LazyDsButtonTertiary],
["DsCardGroup", LazyDsCardGroup],
["DsCardHorizontal", LazyDsCardHorizontal],
["DsCardVertical", LazyDsCardVertical],
["DsCheckbox", LazyDsCheckbox],
["DsDividerSimple", LazyDsDividerSimple],
["DsDropdown", LazyDsDropdown],
["DsDropdownDivider", LazyDsDropdownDivider],
["DsDropdownEmpty", LazyDsDropdownEmpty],
["DsDropdownList", LazyDsDropdownList],
["DsDropdownListBase", LazyDsDropdownListBase],
["DsDropdownListItem", LazyDsDropdownListItem],
["DsDropdownListItemRich", LazyDsDropdownListItemRich],
["DsDropdownSection", LazyDsDropdownSection],
["DsDropzone", LazyDsDropzone],
["DsFieldBase", LazyDsFieldBase],
["DsFieldMultiline", LazyDsFieldMultiline],
["DsFieldNumber", LazyDsFieldNumber],
["DsFieldTags", LazyDsFieldTags],
["DsFieldText", LazyDsFieldText],
["DsHeader", LazyDsHeader],
["DsProfileHeader", LazyDsProfileHeader],
["DsIcon", LazyDsIcon],
["DsImage", LazyDsImage],
["DsDrawer", LazyDsDrawer],
["DsOverlayFooter", LazyDsOverlayFooter],
["DsOverlayHeader", LazyDsOverlayHeader],
["DsRadioButton", LazyDsRadioButton],
["DsSelect", LazyDsSelect],
["DsSidebar", LazyDsSidebar],
["DsSidebarItem", LazyDsSidebarItem],
["DsSidebarItemBase", LazyDsSidebarItemBase],
["DsSidebarItemChild", LazyDsSidebarItemChild],
["DsSidebarSection", LazyDsSidebarSection],
["DsEmptyState", LazyDsEmptyState],
["DsPagination", LazyDsPagination],
["DsTable", LazyDsTable],
["DsTableHeaderCell", LazyDsTableHeaderCell],
["DsTableLine", LazyDsTableLine],
["DsTableLineCellActions", LazyDsTableLineCellActions],
["DsTableLineCellAvatar", LazyDsTableLineCellAvatar],
["DsTableLineCellBase", LazyDsTableLineCellBase],
["DsTableLineCellButtons", LazyDsTableLineCellButtons],
["DsTableLineCellDrag", LazyDsTableLineCellDrag],
["DsTableLineCellIcon", LazyDsTableLineCellIcon],
["DsTableLineCellLabel", LazyDsTableLineCellLabel],
["DsTableLineCellLink", LazyDsTableLineCellLink],
["DsTableLineCellMore", LazyDsTableLineCellMore],
["DsTableLineCellNumeric", LazyDsTableLineCellNumeric],
["DsTableLineCellRich", LazyDsTableLineCellRich],
["DsTableLineCellSelect", LazyDsTableLineCellSelect],
["DsTableLineCellStatus", LazyDsTableLineCellStatus],
["DsTableLineCellTags", LazyDsTableLineCellTags],
["DsTabList", LazyDsTabList],
["DsTabListItem", LazyDsTabListItem],
["DsTag", LazyDsTag],
["DsTagAction", LazyDsTagAction],
["DsTagStatus", LazyDsTagStatus],
["DsTextBody", LazyDsTextBody],
["DsTextHeading", LazyDsTextHeading],
["DsToggle", LazyDsToggle],
["DsTooltip", LazyDsTooltip],
["DsTopbar", LazyDsTopbar],
["DsTopbarInput", LazyDsTopbarInput],
["DsTopbarUserSearch", LazyDsTopbarUserSearch],
["DsTopbarUserSearchItem", LazyDsTopbarUserSearchItem],
["NuxtNotifications", LazyNuxtNotifications],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
